import React from "react";
import { Link } from "react-router-dom";

// import { imagen2 } from "../../images/equipoconstruccion.jpg"
// import { imagen3} from "../../proteccionpersonal.jpg"
// import { imagen4} from "--/../refacciones.png"
import {
    ServiceContainer,
    ServicesH1,
    ServicesWrapper,
    ServicesCard,
    ServicesIcon,
    ServicesH2,
} from "./CategoriesElements";

const Categories = () => {
    return (

        <ServiceContainer id="Categorias">

            <img
                class="mb-20"
                src="https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675709296/Dshop/El_texto_del_p%C3%A1rrafo_2_1_snntwg.gif"
                width={500}
                height={200}
            />
        <ServicesWrapper>

                <ServicesCard>
                    <Link to="/ferreteria">
                        <ServicesIcon src="https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675729895/Dshop/Dise%C3%B1o_sin_t%C3%ADtulo_4_ofyrn8.png" />
                        <ServicesH2>FERRETERIA</ServicesH2>
                    </Link>
                </ServicesCard>
                <ServicesCard>
                    <Link to="/proteccion">
                        <ServicesIcon src="https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675729896/Dshop/Dise%C3%B1o_sin_t%C3%ADtulo_2_z4phmc.png" />
                        <ServicesH2>
                            ELEMENTOS DE PROTECCIÓN PERSONAL
                        </ServicesH2>
                    </Link>
                </ServicesCard>
                <ServicesCard>
                    <Link to="/construccion">
                        <ServicesIcon src="https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675729893/Dshop/Dise%C3%B1o_sin_t%C3%ADtulo_3_naufea.png" />
                        <ServicesH2>
                            {" "}
                            ALQUILER EQUIPOS PARA CONSTRUCCIÓN{" "}
                        </ServicesH2>
                    </Link>
                </ServicesCard>
                <ServicesCard>
                    <Link to="/refacciones">
                        <ServicesIcon src="https://res.cloudinary.com/dsjsbp6qy/image/upload/v1679152802/Dshop/MAKITA_REFACCIONES_header_brands_vebl6z.png" />
                        <ServicesH2>VENTA REFACCIONES</ServicesH2>
                    </Link>
                </ServicesCard>
            </ServicesWrapper>
            </ServiceContainer>
        
    );
};

export default Categories;
